<template>
    <div>
        <div class="datepicker-trigger">
            <input
                    type="text"
                    id="datepicker-trigger"
                    placeholder="Select dates"
                    class="form-control"
                    :value="formatDates(dateOne, dateTwo)"
            >

            <AirbnbStyleDatepicker
                    :trigger-element-id="'datepicker-trigger'"
                    :mode="'range'"
                    :fullscreen-mobile="true"
                    :date-one="dateOne"
                    :date-two="dateTwo"
                    @date-one-selected="val => { dateOne = val }"
                    @date-two-selected="val => { dateTwo = val }"
            />
        </div>
    </div>
</template>

<script>
    import format from 'date-fns/format'

    export default {
        name:"DateRange",
        data() {
            return {
                dateFormat: 'D-MM-YYYY',
                dateOne: '',
                dateTwo: ''
            }
        },
        methods: {
            formatDates(dateOne, dateTwo) {
                let formattedDates = '';
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }
                return formattedDates
            }
        }
    }
</script>